import Text from '../../atoms/Text';

interface ICoinInfoFieldProps {
  name: string;
  value: string;
}

const CoinInfoField = ({ name, value }: ICoinInfoFieldProps) => {
  return (
    <div className='row full_info__row'>
      <Text className='full_info__key' size={12}>
        {name}:
      </Text>
      <Text className='full_info__value' size={12}>
        {value}
      </Text>
    </div>
  );
};

export default CoinInfoField;
